/**
 * Cabeçalhos HTTP no browser exigem Latin-1; Unicode em Bearer/query falha com ByteString.
 */
export function sanitizeHttpHeaderValue(value) {
  if (value == null || value === '') return '';
  return Array.from(String(value), (ch) => (ch.charCodeAt(0) <= 255 ? ch : '')).join('');
}
